import gql from 'graphql-tag'
import api from '../apiClient'

export default {
  authentication: (credenciales, setLocalToken = true) =>
    api
      .send({
        query: gql`
          mutation login($credenciales: loginInput!) {
            User {
              login(input: $credenciales) {
                token
                id
                createdAt
                email
                fullname
                profile
                subprofile
                domain
                crmRole
                viajesRole
                roles {
                  _id
                  name
                  check
                }
              }
            }
          }
        `,
        variables: {
          credenciales
        }
      })
      .then(result => {
        if (process.browser && setLocalToken) localStorage.setItem('sf-session-first', `Bienvenido a JIT ${result.data.data.User.login.fullname || ''}`)
        else console.log('No almacena token local')
        return Promise.resolve(result.data.data.User.login)
      }),

  create: item =>
    api
      .send({
        query: gql`
          mutation create($item: signupInput!) {
            User {
              create(input: $item) {
                id
                fullname
                email
                profile
                subscriptionTimeOut
                token
              }
            }
          }
        `,
        variables: {
          item
        }
      })
      .then(result => {
        if (process.browser) localStorage.setItem('sf-session-first', `Bienvenido a JIT ${result.data.data.User.create.fullname || ''}`)
        return Promise.resolve(result.data.data.User.create)
      }),

  createSystemUser: (input, emisor) =>
    api
      .send({
        query: gql`
          mutation createSystemUser($input: userInput!, $emisor: ID!) {
            User {
              createSystemUser(input: $input, emisor: $emisor)
            }
          }
        `,
        variables: {
          input,
          emisor
        }
      })
      .then(result => Promise.resolve(result.data.data.User.createSystemUser)),

  createUser: (input, emisor) =>
    api
      .send({
        query: gql`
          mutation createUser($input: userInput!, $emisor: ID!) {
            User {
              createUser(input: $input, emisor: $emisor) {
                _id
                username
                fullname
                email
              }
            }
          }
        `,
        variables: {
          input,
          emisor
        }
      })
      .then(result => Promise.resolve(result.data.data.User.createUser)),

  checkreCaptchaAndEmail: (reCaptcha, email) =>
    api
      .send({
        query: gql`
          query checkCaptcha($reCaptcha: String, $email: String!) {
            User {
              checkreCaptchaAndEmail(reCaptcha: $reCaptcha, email: $email)
            }
          }
        `,
        variables: {
          reCaptcha,
          email
        }
      })
      .then(result => Promise.resolve(result.data.data.User.checkreCaptchaAndEmail)),

  recupera: (reCaptcha, email) =>
    api
      .send({
        query: gql`
          mutation RECUPERA($reCaptcha: String, $email: String!) {
            User {
              recupera(reCaptcha: $reCaptcha, email: $email)
            }
          }
        `,
        variables: {
          reCaptcha,
          email
        }
      })
      .then(result => Promise.resolve(result.data.data.User.recupera)),

  recuperaPassword: (reCaptcha, password, hash) =>
    api
      .send({
        query: gql`
          mutation RECUPERA_PASSWORD($reCaptcha: String, $password: String!, $hash: String!) {
            User {
              recuperaPassword(reCaptcha: $reCaptcha, password: $password, hash: $hash)
            }
          }
        `,
        variables: {
          reCaptcha,
          password,
          hash
        }
      })
      .then(result => Promise.resolve(result.data.data.User.recuperaPassword)),

  healthCheck: () =>
    api
      .send({
        query: gql`
          query healthCheck {
            healthCheck
          }
        `
      })
      .then(result => Promise.resolve(result.data.data.healthCheck)),

  getLatestVersion: () =>
    api
      .send({
        query: gql`
          query READ {
            Frontend {
              read
            }
          }
        `
      })
      .then(result => Promise.resolve(result.data.data.Frontend.read)),

  changeSubUserPassword: input =>
    api
      .send({
        query: gql`
          mutation CHANGE_SUBUSER_PASSWORD($input: passwordInput!) {
            User {
              changeSubUserPassword(input: $input)
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => Promise.resolve(result.data.data.User.changeSubUserPassword)),

  changePassword: input =>
    api
      .send({
        query: gql`
          mutation CHANGE_PASSWORD($input: passwordInput!) {
            User {
              changePassword(input: $input)
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => Promise.resolve(result.data.data.User.changePassword)),

  changeProfile: (_id, profile) =>
    api
      .send({
        query: gql`
          mutation CHANGE_PASSWORD($_id: ID!, $profile: String!) {
            User {
              changeProfile(_id: $_id, profile: $profile)
            }
          }
        `,
        variables: {
          _id,
          profile
        }
      })
      .then(result => Promise.resolve(result.data.data.User.changeProfile)),

  setDomain: (input, emisor) =>
    api
      .send({
        query: gql`
          mutation setDomain($input: String!, $emisor: ID!) {
            User {
              setDomain(input: $input, emisor: $emisor)
            }
          }
        `,
        variables: {
          input,
          emisor
        }
      })
      .then(result => Promise.resolve(result.data.data.User.setDomain)),

  readAllByEmisor: emisor =>
    api
      .send({
        query: gql`
          query READ_ALL_USERS($emisor: ID!) {
            User {
              readAllByEmisor(emisor: $emisor) {
                _id
                username
                fullname
                email
                state
                profile
                crmRole
                viajesRole
              }
            }
          }
        `,
        variables: {
          emisor
        }
      })
      .then(result => result.data.data.User.readAllByEmisor),

  readSubUserById: _id =>
    api
      .send({
        query: gql`
          query READ_BY_ID($_id: ID!) {
            User {
              readSubUserById(_id: $_id) {
                _id
                fullname
                email
                waTelefonos
                username
                state
                roles {
                  _id
                  name
                  check
                }
                crmRole
                viajesRole

                createdAt
                updatedAt
              }
            }
          }
        `,
        variables: { _id }
      })
      .then(result => result.data.data.User.readSubUserById),

  delete: (input, emisor) =>
    api
      .send({
        query: gql`
          mutation DELETE($input: [ID!]!, $emisor: ID!) {
            User {
              delete(input: $input, emisor: $emisor) {
                _id
                state
                message
              }
            }
          }
        `,
        variables: { input, emisor }
      })
      .then(result => result.data.data.User.delete),

  checkProfile: _id =>
    api
      .send({
        query: gql`
          query CHECK_PROFILE($_id: ID!) {
            User {
              checkProfile(_id: $_id) {
                profile
                selectedProfile
                subscriptionTimeOut
              }
            }
          }
        `,
        variables: {
          _id
        }
      })
      .then(result => result.data.data.User.checkProfile),

  setProfile: (_id, type, method, card, amount, last4) =>
    api
      .send({
        query: gql`
          mutation SET_PROFILE($_id: ID!, $type: String!, $method: String, $card: Card, $amount: Int) {
            User {
              setProfile(_id: $_id, type: $type, method: $method, card: $card, amount: $amount) {
                token
                id
                email
                fullname
                profile
                domain
                roles {
                  _id
                  name
                  check
                }

                customerId
                paymentMethodId
              }
            }
          }
        `,
        variables: {
          _id,
          type,
          method,
          card,
          amount
        }
      })
      .then(result => result.data.data.User.setProfile),

  getPaymenntMethod: _id =>
    api
      .send({
        query: gql`
          query GET_PAYMENT_METHOD($_id: ID!) {
            User {
              getPaymenntMethod(_id: $_id)
            }
          }
        `,
        variables: {
          _id
        }
      })
      .then(result => result.data.data.User.getPaymenntMethod),

  refreshToken: email =>
    api
      .send({
        query: gql`
          mutation REFRESH($email: String!) {
            User {
              refreshToken(email: $email) {
                token
                id
                email
                fullname
                profile
                subprofile
                domain
                roles {
                  _id
                  name
                  check
                }
              }
            }
          }
        `,
        variables: {
          email
        }
      })
      .then(result => result.data.data.User.refreshToken)

  // TODO: BORRAR LA CUENTA
}
